import { Input, Radio, Row, Space, Form, Col } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const TwoPeriod = ({
    setFieldValue = () => { },
    values = {}
}) => {
    const { t } = useTranslation();

    useEffect(() => {
        setFieldValue("firstPaymentPeriod", "atTheEndOfMonth");
        setFieldValue("secondPaymentPeriod", "atTheEndOfMonth");
    }, [setFieldValue]);

    return (
        <Row gutter={24}>
            <Col span={12}>
                <Form.Item
                    name="firstPaymentPeriod"
                    required
                    label={t("payroll_period.label.payment_fist_period")}
                    labelCol={{ span: 24 }}
                >
                    <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => (
                            <Radio.Group
                                style={{ height: "fit-content" }}
                                onChange={(e) => {
                                    const { value } = e.target
                                    setFieldValue("firstPaymentPeriod", value)
                                }}
                                value={getFieldValue("firstPaymentPeriod") || "atTheEndOfMonth"}
                            >
                                <Space direction="vertical">
                                    <Radio value={"atTheEndOfMonth"}>{t("payroll_period.label.end_of_period")}</Radio>
                                    <Radio value={"everyMonth"}>
                                        {t("payroll_period.label.date")}
                                        <Input
                                            name="inMonth"
                                            style={{ width: 50, marginLeft: 10, marginRight: 10 }}
                                            maxLength={2}
                                            value={values.inMonthValue}
                                            onChange={(e) => {
                                                const { value } = e.target;
                                                setFieldValue("inMonth", value)
                                            }}
                                            disabled={getFieldValue("firstPaymentPeriod") !== "everyMonth"}
                                        // defaultValue={"16"}
                                        />
                                        {t("payroll_period.label.same_month")}
                                    </Radio>
                                </Space>
                            </Radio.Group>
                        )}
                    </Form.Item>
                </Form.Item>
            </Col>
            <Col span={12}>
                <Form.Item
                    name="secondPaymentPeriod"
                    required
                    label={t("payroll_period.label.payment_second_period")}
                    labelCol={{ span: 24 }}
                >
                    <Form.Item noStyle shouldUpdate>
                        {({ getFieldValue }) => (
                            <Radio.Group
                                style={{ height: "fit-content" }}
                                onChange={(e) => {
                                    const { value } = e.target
                                    setFieldValue("secondPaymentPeriod", value)
                                }}
                                value={getFieldValue("secondPaymentPeriod") || "atTheEndOfMonth"}
                            >
                                <Space direction="vertical">
                                    <Radio value={"atTheEndOfMonth"}>{t("payroll_period.label.same_month_end")}</Radio>
                                    <Radio value={"nextMonth"}>
                                        {t("payroll_period.label.date")}
                                        <Input
                                            name="nextMonth"
                                            style={{ width: 50, marginLeft: 10, marginRight: 10 }}
                                            maxLength={2}
                                            value={values.nextMonthValue}
                                            onChange={(e) => {
                                                const { value } = e.target;
                                                setFieldValue("nextMonth", value);
                                            }}
                                            disabled={getFieldValue("secondPaymentPeriod") !== "nextMonth"}
                                        // defaultValue={"1"}
                                        />
                                        {t("payroll_period.label.next_month")}
                                    </Radio>
                                </Space>
                            </Radio.Group>
                        )}
                    </Form.Item>
                </Form.Item>
            </Col>
        </Row>
    )
}

export default TwoPeriod;